export default __webpack_public_path__ + "static/media/no-notification.08126cfe.jpg";